import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {makePreferences, updatePreferences} from '../actionCreators/preferences';
import {truncatedFilename} from '../actionCreators/uploadPdf';
import * as DigitalAssetApi from '../api/DigitalAssetApi';
import * as reportSections from '../ducks/reportSections';
import {findSection} from '../ducks/reportSections';
import AnalyticsGateway from '../lib/AnalyticsGateway';
import {getIn} from '../lib/immutableObject';
import ReportSectionToggle from './ReportSectionToggle';

const mapStateToProps = (state, ownProps) => {
  const reportType = state.reportType.value;
  return {
    propertyId: state.propertyDetail.propertyId,
    reportType,
    section: findSection(state.reportSections, reportType, ownProps.sectionKey, ownProps.sectionUrl),
    included: ownProps.included,
    sectionUrl: ownProps.sectionUrl,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    onClick: (reportType, propertyId, section, isIncluded) => {
      let preferences = {};

      let notificationMessage;

      if (isIncluded !== undefined) {
        preferences = makePreferences({}, ownProps.sectionKey, ownProps.sectionUrl, 'included', isIncluded);
        if (isIncluded) {
          dispatch(reportSections.includeSectionInReport(reportType, ownProps.sectionKey, ownProps.sectionUrl));
          notificationMessage = 'Report section added. We\'ll remember this next time you make a report.';
        } else {
          dispatch(reportSections.excludeSectionFromReport(reportType, ownProps.sectionKey, ownProps.sectionUrl));
          notificationMessage = 'Report section removed. We\'ll remember this next time you make a report.';
        }
      }

      if (!['COMPARABLE_MAP', 'COMPARABLE_SALES_MAP', 'COMPARABLE_LISTINGS_MAP', 'COMPARABLE_RENTALS_MAP'].includes(section.key)) {
        makePreferences(preferences, ownProps.sectionKey, ownProps.sectionUrl, 'index');
        dispatch(updatePreferences(preferences, reportType, notificationMessage));
      }

      AnalyticsGateway.sendEvent({
        eventName: `${isIncluded ? 'Add' : 'Remove'} Section from Report`,
        properties: [
          {label: 'Page', value: 'Customise'},
          {label: 'Property ID', value: propertyId},
          {label: 'Report Type', value: reportType},
          {label: 'Section Type', value: section.key === 'CUSTOM' ? 'Custom PDF' : 'Default Section'},
          {label: 'Section Name', value: section.key === 'CUSTOM' ? truncatedFilename(section.filename) : section.uiLabel},
          {label: 'Section Title', value: section.key === 'CUSTOM' ? section.uiLabel : getIn(section, ['sectionData', 'title'])},
        ]
      });

      if (ownProps.onClick) {
        ownProps.onClick();
      }
    },

    onDelete: (reportType, propertyId, section) => {
      dispatch(reportSections.removeSectionFromReport(reportType, ownProps.sectionUrl));

      let preferences = makePreferences({}, 'CUSTOM', ownProps.sectionUrl, 'filename');
      makePreferences(preferences, 'CUSTOM', ownProps.sectionUrl, 'included');
      makePreferences(preferences, 'CUSTOM', ownProps.sectionUrl, 'index');
      makePreferences(preferences, 'CUSTOM', ownProps.sectionUrl, 'uiLabel');
      dispatch(updatePreferences(preferences, reportType));

      AnalyticsGateway.sendEvent({
        eventName: 'Delete Custom PDF',
        properties: [
          {label: 'Page', value: 'Customise'},
          {label: 'Property ID', value: propertyId},
          {label: 'Report Type', value: AnalyticsGateway.reportDescription(reportType)},
          {label: 'Custom PDF Filename', value: section.filename},
          {label: 'Section Type', value: 'Custom PDF'},
          {label: 'Section Name', value: truncatedFilename(section.filename)},
          {label: 'Section Title', value: section.uiLabel},
        ]
      });

      DigitalAssetApi.deleteAsset(ownProps.sectionUrl);

      if(ownProps.onDelete){
        ownProps.onDelete();
      }
    }
  };
};

const mergeProps = (stateProps, dispatchProps) => {
  return {
    ...stateProps,
    ...dispatchProps,
    onClick: (isIncluded) => {
      dispatchProps.onClick(stateProps.reportType, stateProps.propertyId, stateProps.section, isIncluded);
    },
    onDelete: () => {
      dispatchProps.onDelete(stateProps.reportType, stateProps.propertyId, stateProps.section);
    }
  };
};

const ReportSectionToggleContainer = connect(mapStateToProps, mapDispatchToProps, mergeProps)(ReportSectionToggle);
ReportSectionToggleContainer.propTypes = {
  sectionKey: PropTypes.string.isRequired,
  sectionUrl: PropTypes.string,
  included: PropTypes.bool,
};
export default ReportSectionToggleContainer;
